import HomeIcon from '@material-ui/icons/Home';

const firebaseDrawerRoutes = [
  {
    id: 'first-section',
    routes: [
      {
        path: '/',
        labelId: 'seed.home.drawer',
        Icon: HomeIcon,
      },
    ],
  },
];

export default firebaseDrawerRoutes;
